import dayjs from 'dayjs';
import Locker from 'lockr';
import { useEffect } from 'react';
import { useFeatureVariable } from 'v2/core/clients/featureFlag';
import { FeatureFlagVariable } from 'v2/core/clients/featureFlag/flags';
import { ExpiryConfigVariable } from './types';

const FORCE_LOGOUT_DONE = 'force_logout_done';

export const ForceLogoutFeatureFlag: FeatureFlagVariable<ExpiryConfigVariable> =
  {
    name: 'force_logout',
    variableName: 'config',
    fallback: {
      uid: null,
      expiry: null,
    },
  };

export function LogoutIfRequired() {
  const [, { uid, expiry }] = useFeatureVariable(ForceLogoutFeatureFlag);

  useEffect(() => {
    if (!uid) {
      return;
    }

    if (expiry) {
      const expiryTimestamp = dayjs(expiry).valueOf();
      const now = Date.now();

      if (now > expiryTimestamp) {
        return;
      }
    }

    const logoutKey = `${FORCE_LOGOUT_DONE}_${uid}`;
    const isForceLogoutDone = Locker.get(logoutKey);

    if (!isForceLogoutDone) {
      Locker.set(logoutKey, true);
      window.location.href = '/logout';
    }
  }, [uid, expiry]);

  return null;
}
